import EntityListManager from './EntityListManager';
import {
  getLeadActions,
  createLeadAction,
  updateLeadAction,
  deleteLeadAction,
  reorderLeadActions,
} from '../../services/leadService';

export default function LeadActionManager({ onMessage }) {
  return (
    <EntityListManager
      onMessage={onMessage}
      title="Lead Actions"
      description="Manage actions that can be assigned to leads for tracking next steps."
      entityNoun="Action"
      entityNounPlural="Actions"
      idKey="action_id"
      namePlaceholder="e.g. Site Visit, Send Quote, Follow Up"
      load={() => getLeadActions().then((d) => d.actions)}
      create={createLeadAction}
      update={updateLeadAction}
      remove={deleteLeadAction}
      reorder={(ids) => reorderLeadActions(ids).then((d) => d.actions)}
      deleteWarning={(item) => `Are you sure you want to delete the "${item.name}" action? Leads using this action will have their action cleared.`}
    />
  );
}
